// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2). The rows here are EnvItem / DomainItem cards (title + description +
// trailing action), not menu-command rows, so they keep their own chassis —
// only the shell re-homes. Deleted with the re-chassis: the `margin:
// '- -Z2'` pulls on every group (they compensated the old hand-rolled
// `padding: 'Z1 A'` body; MenuPanel pads Y and the rows' own Z2 padding
// provides the hover-box inset, so a -Z2 pull would overflow the panel by
// Z2 − Y and clip), and the two `Line` dividers — the C gap + the group
// captions separate the sections (§7.7 default: gap, not hairlines).
const Dropdownenvs = {
  extends: 'MenuPanel',
  gap: 'C',
  textAlign: 'start',
  width: 'G1',
  Envs: {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
      // Align the caption with the EnvItem/DomainItem rows' Z2 content inset.
      padding: '- Z2',
      Text: {
        text: '{{ publish.envs.title | polyglot }}'
      }
    },
    Flex: {
      gap: 'A',
      flow: 'y',
      childExtends: 'EnvItem',
      Prod: {
        Hgroup: {
          H: {
            text: '{{ publish.envs.production | polyglot }}'
          },
          P: {
            text: '{{ publish.envs.productionHint | polyglot }}'
          }
        }
      },
      Test: {
        Hgroup: {
          H: {
            text: '{{ publish.envs.test | polyglot }}'
          },
          P: {
            text: '{{ publish.envs.testHint | polyglot }}'
          }
        }
      },
      Dev: {
        extends: ['CanvasButton', 'EnvItem'],
        isActive: true,
        Circle: {
          isActive: true
        },
        Hgroup: {
          H: {
            text: '{{ publish.envs.development | polyglot }}'
          },
          P: {
            text: '{{ publish.envs.developmentHint | polyglot }}'
          }
        },
        Buttons: {
          hide: false
        },
        Upgrade: null
      }
    }
  },
  EnvItem_Local: {
    Hgroup: {
      H: {
        text: '{{ publish.envs.local | polyglot }}'
      },
      P: {
        text: (el) => `localhost:1234`
      }
    },
    Upgrade: null,
    Connect: {
      extends: 'Link',
      color: 'title',
      text: '{{ publish.sync.connect | polyglot }}',
      margin: '- - - auto',
      alignSelf: 'start',
      whiteSpace: 'nowrap',
      fontSize: 'Z2',
      lineHeight: 1,
      ':hover': {
        textDecoration: 'underline'
      },
      onClick: (f, el, st) => {
        el.call('openRouterModal', '/settings', {
          key: '/connect'
        })
      }
    }
  },
  Domains: {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
      padding: '- Z2',
      Text: {
        text: '{{ publish.domains.title | polyglot }}'
      }
    },
    Flex: {
      gap: 'A',
      flow: 'y',
      childExtends: 'DomainItem',
      Custom: {
        Hgroup: {
          H: {
            text: '{{ publish.domains.custom | polyglot }}'
          },
          P: {
            text: '{{ publish.domains.customHint | polyglot }}'
          }
        }
      },
      Lookup: {
        Hgroup: {
          H: {
            text: '{{ publish.domains.find | polyglot }}'
          },
          P: {
            text: '{{ publish.domains.findHint | polyglot }}'
          }
        },
        Upgrade: null,
        Icon: {
          name: 'sf search'
        },
        // The modal's "New domain" step — registration through Symbols is
        // still "coming soon" there, with a one-click path back to linking.
        onClick: (e, el) => {
          e.preventDefault()
          el.call('openProjectDomainFlow', { step: 'new' })
        }
      }
    }
  }
}

export { Dropdownenvs as 'Dropdown.Envs' }
